import React from "react";

export default function ExperienceTab() {
  return (
    <div
      className="row"
      id="experienceTab"
      data-aos="fade-in"
      data-aos-easing="linear"
      data-aos-delay="0"
      data-aos-duration="500"
    >
      <div className="col-12 col-lg-6">
        <div className="content">
          <span className="subtitle my-1 text-start">2022</span>
          <h4 className="title my-0 text-start">Job Experience</h4>
          <div className="list">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body p-0">
                  <div className="heading">
                    <div className="card-title">
                      <h4>Software Engineer</h4>
                      <span>
                        Rareprob Solution Pvt. Ltd. (Nov 2022 - Present)
                      </span>
                    </div>
                  </div>
                  <div className="card-text">
                    <ul>
                      <li>
                        Conducted comprehensive testing of Android applications,
                        iOS applications, and websites developed by RareProb
                        Solution Pvt Ltd.
                      </li>
                      <li>
                        Collaborated with cross-functional teams, including
                        developers and product managers, to identify and
                        document software defects and ensure their timely
                        resolution.
                      </li>
                      <li>
                        Developed and executed test plans, test cases, and test
                        scripts to ensure the quality and reliability of
                        software products.
                      </li>
                      <li>
                        Utilized a range of testing methodologies, including
                        manual testing and automated testing tools, to perform
                        functional, performance, and regression testing.
                      </li>
                      <li>
                        Played a key role in bug tracking, issue reporting, and
                        providing detailed test reports to stakeholders.
                      </li>
                      <li>
                        Active participation in Agile development processes,
                        including sprint planning, daily stand-ups, and
                        retrospective meetings.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-6 mt-5 mt-lg-0">
        <div className="content">
          <span className="subtitle my-1 text-start">2022</span>
          <h4 className="title my-0 text-start">Internship Project</h4>
          <div className="list">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body p-0">
                  <div className="heading">
                    <div className="card-title">
                      <h4>Ticket Management System</h4>
                      <span>NASCOM (Mar 2022)</span>
                    </div>
                  </div>
                  <div className="card-text">
                    <ul>
                      <li>
                        The Ticket Management System (TMS) internship project
                        aims to develop a comprehensive web-based application.
                      </li>
                      <li>
                        The system will facilitate efficient handling of
                        customer inquiries, support requests, and issue
                        tracking.
                      </li>
                      <li>
                        It will include features such as user authentication,
                        ticket creation, assignment.
                      </li>
                      <li>
                        This project will provide valuable experience in
                        full-stack development and database management.
                      </li>
                      <li>
                        Technologies Used in Backend Development: Java, Spring
                        Boot, Hibernate.
                        <br></br>Frontend Development: HTML,CSS, JavaScript,
                        Bootstrap.
                        <br></br>Database: MySQL
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
